module.exports = __webpack_public_path__ + "img/actions.1a66cd64.svg";